module.exports = __webpack_public_path__ + "img/lapnotificationvthoutred.510eccc5.svg";